module.exports = __webpack_public_path__ + "img/mol.7319efbe.png";